import { Button, ButtonProps } from "@chakra-ui/react";
import React from "react";

export interface PrimaryButtonProps extends ButtonProps {
  onlyButton?: boolean;
}

const PrimaryButton: React.FC<PrimaryButtonProps> = ({
  children,
  onlyButton,
  _hover,
  _active,
  ...styleProps
}) => {
  const hasText = Boolean(children);
  const isIconOnly = !hasText;

  return (
    <Button
      rightIcon={!onlyButton ? styleProps.rightIcon : undefined}
      leftIcon={!onlyButton ? styleProps.leftIcon : undefined}
      rounded={!onlyButton ? "28px" : "full"}
      py={!onlyButton ? styleProps.py ?? "14px" : "0px"}
      px={!onlyButton ? styleProps.px ?? "20px" : "0px"}
      display="flex"
      alignItems={styleProps.alignItems ?? "center"}
      justifyContent={styleProps.justifyContent ?? "center"}
      fontWeight="600"
      size={!onlyButton ? styleProps.size ?? "md" : "md"}
      iconSpacing={isIconOnly ? 0 : styleProps.iconSpacing ?? 2}
      w={!onlyButton ? styleProps.w ?? "212.82px" : styleProps.w}
      h={styleProps.h ?? "60px"}
      gap={styleProps.gap ?? "10px"}
      bg={styleProps.bg ?? "#D1F801"}
      color={styleProps.color ?? "#0367FD"}
      transition="all 0.25s ease-in-out"
      _hover={{ transform: "translateY(-2px)", filter: "brightness(1.15)", boxShadow: "md", bg: _hover?.bg ?? "#e5ff45", ..._hover }}
      _active={{ transform: "translateY(0px)", filter: "brightness(0.95)", boxShadow: "sm", ..._active }}
      opacity={styleProps.opacity ?? 1}
      {...styleProps}
    >
      {children}
    </Button>
  );
};

export default PrimaryButton;
